module.exports = __webpack_public_path__ + "static/media/Distributions.17663ded.png";